import { useAppContext } from '@/Main';
import classNames from 'classnames';
import { CloseButton } from 'react-bootstrap';
import { ComponentProps } from 'react';

type FalconCloseButtonProps = ComponentProps<typeof CloseButton> & {
  size?: string;
  noOutline?: boolean;
  className?: string;
};

const FalconCloseButton = ({
  size,
  onClick,
  noOutline,
  variant,
  className,
  ...rest
}: FalconCloseButtonProps) => {
  const {
    config: { isDark }
  } = useAppContext();

  return (
    <CloseButton
      variant={variant ? variant : isDark ? 'white' : undefined}
      className={classNames('btn', {
        [`btn-${size}`]: size,
        'outline-none': noOutline,
        [className ?? '']: Boolean(className)
      })}
      onClick={onClick}
      {...rest}
    />
  );
};

export default FalconCloseButton;
